import Vue from 'vue'
import Router from 'vue-router'
import Cookies from "js-cookie"
import Index from '@/components/index'

import jyyrIndex from '@/view/indexPage'
// import jyyrIndex from '@/view/indexPageC'
Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const goPageShow = window.location.origin.split('//')[1].indexOf('localhost') > -1 || window.location.origin.split('//')[1].indexOf('jiuyeyuren') > -1 || window.location.origin.split('//')[1].indexOf('biyeshen') > -1 || window.location.origin.split('//')[1].indexOf('applyoffer') > -1
sessionStorage.setItem('diffPage', goPageShow)
const indexPage = goPageShow ? jyyrIndex : Index

const jiuyeyuren = window.location.origin.split('//')[1].indexOf('jiuyeyuren') > -1
// 9月1号改回浏览器标题就业育人-招聘会
const changeTitle = jiuyeyuren ? '就业育人-招聘会' : '毕业申-校招求职、实习、企业招聘'
// const changeTitle = jiuyeyuren ? '清飞信息' : '毕业申-专注于校园招聘'



const router = new Router({
  routes:[
    // {
    //   path:"*",
    //   redirect:"/"
    // },
    {
      path: '/',
      name: 'index',
      meta: {
        isOtherLoginBox: goPageShow,
        // title: '就业育人-首页'
        title: changeTitle,
        activeHome: 'home'
      },
      component: indexPage
    },
    {
      path: '/about',
      name: 'about',
      meta: {
        title: '关于毕业申'
      },
      component: () => import('@/view/about/about.vue')
    },
    {
      path: '/jobRecommend',
      name: 'JobRecommend',
      meta: {
        title: '职位推荐',
        activeHome: 'jobRecommend'
      },
      component: () => import('@/view/jobRecommend/jobRecommend.vue')
    },
    {
      path: '/resume',
      name: 'ResumDetail',
      meta: {
        isOtherLoginBox: false,
        title: '简历详情'
      },
      component: () => import('@/view/resume/resume_detail.vue')
    },
    {
      path: '/resume_add',
      name: 'ResumAdd',
      meta: {
        isOtherLoginBox: false,
        title: '添加简历'
      },
      component: () => import('@/view/resume_add.vue')
    },
    {
      path: '/resume_create',
      name: 'ResumCreate',
      meta: {
        isOtherLoginBox: false,
        title: '创建简历'
      },
      component: () => import('@/view/resume_create.vue')
    },
    {
      path: '/attentdetail',
      name: 'Attentdetail',
      meta: {
        isOtherLoginBox: false,
        title:'简历预览'
      },
      component: () => import('@/view/attentdetail.vue')
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/view/login.vue')
    },
    {
      path: '/videoDetail',
      name: 'videoDetail',
      meta: {
        isOtherLoginBox: true,
        title: '视频详情',
        isFooterFlag: true
      },
      component: () => import('@/view/videoDetail/videoDetail.vue')
    },
    {
      path: '/companyDetailPage',
      name: 'companyDetailPage',
      meta: {
        title: '公司详情'
      },
      component: () => import('@/view/detailPage/companyPage/companyDetailPage.vue')
    },
    {
      path: '/positionList',
      name: 'positionList',
      meta: {
        title: '职位列表'
      },
      component: () => import('@/view/positionList/positionList.vue')
    },
    {
      path: '/job',
      name: 'positionDetailPage',
      meta: {
        title: '职位详情'
      },
      component: () => import('@/view/detailPage/positionPage/positionDetailPage.vue')
    },
    {
      path: '/deliveryFeedback',
      name: 'deliveryFeedback',
      meta: {
        title: '投递反馈'
      },
      component: () => import('@/view/detailPage/deliveryFeedback/deliveryFeedback.vue')
    },
    {
      path: '/myCollect',
      name: 'myCollect',
      meta: {
        title: '我的收藏'
      },
      component: () => import('@/view/detailPage/myCollect/myCollect.vue')
    },
    {
      path: '/jobFair',
      name: 'jobFair',
      meta: {
        title: '招聘会'
      },
      component: () => import('@/view/jobFair/jobFair.vue')
    },
    {
      path: '/floorplan',
      name: 'floorplan',
      meta: {
        title: '展位图'
      },
      component: () => import('@/view/floorplan/floorplan.vue')
    },
    {
      path: '/companyList',
      name: 'companyList',
      meta: {
        title: '企业列表',
        activeHome: 'company'
      },
      component: () => import('@/view/companyList/companyList.vue')
    },
    {
      path: '/wenList',
      name: 'wenList',
      meta: {
        title: '文章列表'
      },
      component: () => import('@/view/wenList/wenList.vue')
    },
    {
      path: '/wenDetail',
      name: 'wenDetail',
      meta: {
        title: '文章详情'
      },
      component: () => import('@/view/wenDetail/wenDetail.vue')
    },
    {
      path: '/contentListNew',
      name: 'contentListNew',
      meta: {
        title: '内容列表页新'
      },
      component: () => import('@/view/contentListNew/contentListNew.vue')
    },
    {
      path: '/collegePosition',
      name: 'collegePosition',
      meta: {
        title: '院系',
        activeHome: 'collegePosition'
      },
      component: () => import('@/view/college/collegePosition.vue')
    },
    {
      path: '/collegeCompany',
      name: 'collegeCompany',
      meta: {
        title: '院系-企业',
        activeHome: 'collegeCompany'
      },
      component: () => import('@/view/college/collegeCompany.vue')
    },
    {
      path: '/collegeJobfair',
      name: 'collegeJobfair',
      meta: {
        title: '院系-招聘会',
        activeHome: 'collegeJobfair'
      },
      component: () => import('@/view/college/collegeJobfair.vue')
    },
    {
      path: '/transferPage',
      name: 'transferPage',
      meta: {
        title: ''
      },
      component: () => import('@/view/college/transferPage.vue')
    },
    {
      path: '/aiIntelligentfilling',
      name: 'aiIntelligentfilling',
      meta: {
        title: '产品介绍',
        activeHome: 'aiResume'
      },
      component: () => import('@/view/aiResume/aiIntelligentfilling.vue')
    },
    {
      path: '/aiResumeBasicInfo',
      name: 'aiResumeBasicInfo',
      meta: {
        title: '基本信息',
        activeHome: 'aiResume'
      },
      component: () => import('@/view/aiResume/aiResumeBasicInfo.vue')
    },
    {
      path: '/aiResumeDetail',
      name: 'ai_resume_detail',
      meta: {
        title: 'AI简历详情',
        activeHome: 'aiResume'
      },
      component: () => import('@/view/aiResume/resume/resume_detail.vue')
    },
    {
      path: '/aiIntroduction',
      name: 'aiIntroduction',
      meta: {
        title: '产品介绍',
        activeHome: 'aiResume'
      },
      component: () => import('@/view/aiDiagnosis/introductionDescription.vue')
    },
    {
      path: '/createdBasicInfo',
      name: 'createdBasicInfo',
      meta: {
        title: '基本信息确认和选择职位填写',
        activeHome: 'aiResume'
      },
      component: () => import('@/view/aiDiagnosis/aiDiagnosisBasicInfo.vue')
    },
    {
      path: '/diagnosticResult',
      name: 'diagnosticResult',
      meta: {
        title: '诊断结果',
        activeHome: 'aiResume'
      },
      component: () => import('@/view/aiDiagnosis/diagnosticResult.vue')
    },
    {
      path: '/interviewRoom',
      name: 'interviewRoom',
      meta: {
        title: '面试间',
        activeHome: 'interviewRoom'
      },
      component: () => import('@/view/aiInterview/interviewRoom.vue')
    },
    {
      path: '/aiInterviewIntroduce',
      name: 'aiInterviewIntroduce',
      meta: {
        title: '产品介绍',
        activeHome: 'interviewRoom'
      },
      component: () => import('@/view/aiInterview/aiInterviewIntroduce.vue')
    },
    {
      path: '/aiInterviewResult',
      name: 'aiInterviewResult',
      meta: {
        title: '面试结果',
        activeHome: 'interviewRoom'
      },
      component: () => import('@/view/aiInterview/aiInterviewResult.vue')
    },
    {
      path: '/aiInterviewBasicInfo',
      name: 'aiInterviewBasicInfo',
      meta: {
        title: '基本信息确认和选择职位填写',
        activeHome: 'interviewRoom'
      },
      component: () => import('@/view/aiInterview/aInterviewBasicInfo.vue')
    },
    {
      path: '/ruleIntroduction',
      name: 'ruleIntroduction',
      meta: {
        title: '规则介绍',
        activeHome: 'interviewRoom'
      },
      component: () => import('@/view/aiInterview/ruleIntroduction.vue')
    },
    {
      path:"*",
      redirect:"/"
    },
  ],
  mode: 'hash',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

const LOGIN_PAGE_NAME = 'Login'

router.beforeEach((to, from, next) => {
  if(goPageShow) {

    document.title = to.meta.title
    document.querySelector("meta[name='keyword']").setAttribute('content', '校园招聘,校招,求职,招聘,应届生求职,大学生找工作,实习,实习僧,智联招聘,前程无忧');
    document.querySelector("meta[name='description']").setAttribute('content', `${jiuyeyuren ? '就业育人' : '毕业申'}，专注于校招、实习的平台，各大高校的官方合作平台。注册企业超过二十万家，覆盖上千所高校，已帮助上百万学生入职。每日更新最新最全的职位。`);
  }
  if (!Cookies.get("user_id") && to.name !== LOGIN_PAGE_NAME) {
    // 未登录且要跳转的页面不是登录页
    next()
    // if(to.name == 'index'){
    //   next()
    // }else{
    //   next({
    //     name: LOGIN_PAGE_NAME // 跳转到登录页
    //   })
    // }

  } else if (!Cookies.get("user_id") && to.name === LOGIN_PAGE_NAME) {
    // 未登陆且要跳转的页面是登录页
    next() // 跳转
    // } else if (token && to.name === LOGIN_PAGE_NAME) {
    //   // 已登录且要跳转的页面是登录页
    //   next({
    //     name: homeName // 跳转到homeName页
    //   })
  } else { // 其他页
    next()
  }
})


export default router




// WEBPACK FOOTER //
// ./src/router/index.js